// extracted by mini-css-extract-plugin
export default {"container":"Mk-z","freeShip":"Nk-z","privacy":"Ok-z"};